// @flow
import type { Action, Client, GetState, Role } from 'state/types';
import {
  CREATE_ROLE,
  CREATE_ROLE_FAIL,
  CREATE_ROLE_SUCCESS,
  DELETE_ROLE,
  DELETE_ROLE_FAIL,
  DELETE_ROLE_SUCCESS,
  GET_ROLES,
  GET_ROLES_FAIL,
  GET_ROLES_SUCCESS,
  SET_SELECTED_ROLE,
  UPDATE_ROLE,
  UPDATE_ROLE_FAIL,
  UPDATE_ROLE_SUCCESS,
} from 'state/types/roleTypes';
import type { RoleState } from 'state/types/roleTypes';

import { API } from 'util/constants';
import { sortRoles } from 'util/roleUtils';

const initialState: RoleState = {
  roles: [],
  selectedRoleId: null,
};

export default function reducer(
  state: RoleState = initialState,
  action: Action
) {
  switch (action.type) {
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: sortRoles(action.payload),
      };
    case SET_SELECTED_ROLE:
      return {
        ...state,
        selectedRoleId: action.payload.uuid,
      };
    default:
      return state;
  }
}

function createRole(identitySession: string, roleName: string) {
  return {
    types: [CREATE_ROLE, CREATE_ROLE_SUCCESS, CREATE_ROLE_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/role`, {
        params: { session: identitySession, roleName: roleName },
      }),
  };
}

function deleteRole(identitySession: string, roleName: string) {
  return {
    types: [DELETE_ROLE, DELETE_ROLE_SUCCESS, DELETE_ROLE_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.delete(`${API}/role`, {
        params: { session: identitySession, roleName: roleName },
      }),
  };
}

function getRoles(identitySession: string) {
  return {
    types: [GET_ROLES, GET_ROLES_SUCCESS, GET_ROLES_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/role`, {
        params: { session: identitySession },
      }),
  };
}

function updateRole(
  identitySession: string,
  roleName: string,
  grant: string,
  revoke: string
) {
  return {
    types: [UPDATE_ROLE, UPDATE_ROLE_SUCCESS, UPDATE_ROLE_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/role/${roleName}`, {
        params: {
          session: identitySession,
          grants: grant,
          revokes: revoke,
        },
      }),
  };
}

function setSelectedRole(role: Role) {
  return {
    type: SET_SELECTED_ROLE,
    payload: role,
  };
}

export const actions = {
  createRole,
  deleteRole,
  getRoles,
  setSelectedRole,
  updateRole,
};



// WEBPACK FOOTER //
// ./src/state/reducers/roleReducer.js